import {Textarea} from "@/components/ui/textarea";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {cn} from "@/lib/utils";


export default function CWFTextarea({control, name, className, inputClassName, label, placeholder, ...props}){
    return (
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("grid w-full items-center h-max gap-1.5 space-y-0", className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        <Textarea
                            placeholder={placeholder ?? label ?? undefined}
                            {...props}
                            value={field.value ?? ""}
                            onChange={field.onChange}
                            className={inputClassName}
                        />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}